import React from 'react';
import { Typography } from "antd";

export function renderCopyable(text: any) {
    if (typeof text == "string" && text.length > 0) {
        return <Typography.Paragraph style={{ marginBottom: 0 }} ellipsis copyable={{ text }} >{text}</Typography.Paragraph>;
    }
    return text;
}